Space1.Elements = {
    appConfig: null,
    routingMap: {
        'administration/partners/partner-client-apps': 'Partners/PartnerClientApps/__partnerId__',
        'administration/partners/partner-licenses': 'LicenseManager/Index/__partnerId__',
        'administration/companies': 'Companies?filterPartnerId=__partnerId__',
        'training/lessons': 'Lessons'
    },

    init() {
        this.appConfig = document.querySelector('sp1-app-config');
        if (this.appConfig) {
            this.attachNavigationListener();
        }
    },

    attachNavigationListener() {
        this.appConfig.addEventListener('navigateTo', (event) => {
            const destination = event.detail[0];
            const routeParams = event.detail[1];

            const urlSchema = this.routingMap[destination];
            if (urlSchema) {
                let url = urlSchema;

                if (routeParams) { 
                    Object.keys(routeParams).forEach(paramName => {
                        const paramValue = routeParams[paramName];
                        url = url.replace(`__${paramName}__`, paramValue);
                    });
                }

                if (url) {
                    window.location = `${Space1.Env.getWebRootPath()}/${url}`;
                }
            }
        });
    }
}


